import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const Description = (props) => {
  return (
    <FormGroup controlId="description">
      <Col componentClass={ControlLabel} sm={5}>
        Description
      </Col>
      <Col sm={7}>
        <FormControl type="text" value={props.description} onChange={props.handleChangeDescription}
          autoComplete="off" />
      </Col>
    </FormGroup>
  )
}

Description.propTypes = {
  description: PropTypes.string,
  handleChangeDescription: PropTypes.func
};

export default Description;



// WEBPACK FOOTER //
// ./src/app/components/description/Description.js